<template>
  <div class="pascal-principle-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F₁ / A₁ = F₂ / A₂ | 液压机力传导$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Fluid Container -->
          <path d="M 50,180 L 350,180" fill="none" stroke="#22a6b3" stroke-width="40" opacity="0.4" />
          <rect x="50" y="80" width="40" height="100" fill="rgba(34, 166, 179, 0.4)" stroke="#888" />
          <rect x="310" y="80" width="80" height="100" fill="rgba(34, 166, 179, 0.4)" stroke="#888" />
          
          <!-- Small Piston (Input) -->
          <g :transform="`translate(50, ${100 + inputY})`">
             <rect width="40" height="10" fill="#333" />
             <path d="M 20,-40 L 20,0" stroke="#888" stroke-width="2" />
             <text x="0" y="-45" fill="#fff" font-size="8">输入力 F1</text>
          </g>

          <!-- Large Piston (Output) -->
          <g :transform="`translate(310, ${100 - inputY/4})`">
             <rect width="80" height="10" fill="#333" />
             <path d="M 40,-60 L 40,0" stroke="#888" stroke-width="2" />
             <text x="15" y="-65" fill="#fff" font-size="8">输出力 F2 (4倍)</text>
             
             <!-- Heavy Load -->
             <rect x="10" y="-40" width="60" height="30" fill="#555" rx="2" />
             <text x="25" y="-20" fill="#fff" font-size="8">重物</text>
          </g>

          <!-- Pressure indicators (Dots) -->
          <circle v-for="n in 10" :key="n" :cx="100 + n*20" cy="180" r="2" fill="#fff">
             <animate attributeName="opacity" values="0.2;1;0.2" :dur="`${2/(inputY+10)}s`" repeatCount="indefinite" />
          </circle>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>压强 P: {{ (inputY * 0.5).toFixed(1) }} kPa (处处相等)</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>施加输入力 F1 (位移控制)</label>
             <el-slider v-model="inputY" :min="0" :max="60" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>帕斯卡原理指出，在密闭流体中，向任何一部分施加的压强增量，会大小不变地由流体向**各个方向**传递。利用这个特性，在面积较小的活塞上施加一个小力，就能在面积较大的活塞上产生一个巨大的升力。功虽然不变（省力费位移），但它让我们可以用单手托起汽车。这是液压千斤顶、刹车系统和工程挖掘机的核心原理。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PascalPrincipleViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      inputY: 0
    }
  }
}
</script>

<style scoped lang="scss">
.pascal-principle-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
